@if (loaderService.loading) {
  <app-loader />
} @if (slideMenuService.showed) {
  <app-slide-menu />
}
<router-outlet></router-outlet>
